import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close, InfoRounded } from '@mui/icons-material';
import { VOICE_STATUS } from '@src/constants/voiceCloning';
import CommonButton from '@src/new-components/Button';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { LANDING_PAGE_URL, VBEE_ZALO_URL } from '@src/configs';
import sanitize from 'sanitize-html';
import { StyledViewReasonNew } from './index.style';

const ViewReasonNew = ({
  open,
  note,
  onClose,
  voiceStatus,
  onDuplicateVoice,
  isDuplicateVoice,
  handleClickGenerateVoice,
}) => {
  const { t } = useTranslation();

  const handleDuplicateVoice = () => {
    onClose();
    if (!isDuplicateVoice && handleClickGenerateVoice) {
      handleClickGenerateVoice();
      return;
    }
    if (isDuplicateVoice && onDuplicateVoice) {
      onDuplicateVoice();
    }
  };

  const handleUnderstood = () => {
    onClose();
  };

  const getTitle = () => {
    if (voiceStatus === VOICE_STATUS.SUSPENDED) {
      return t('suspended');
    }
    if (voiceStatus === VOICE_STATUS.FAILED) {
      return t('reasonFail');
    }
    return t('reason');
  };

  return (
    <StyledViewReasonNew open={open} onClose={onClose}>
      <DialogTitle classes={{ root: 'dialog-title' }}>
        <Typography variant="body-20-bold" className="title">
          {getTitle()}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="close-button"
        >
          <Close sx={{ color: COLOR.darkBlue }} />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: 'dialog-content' }}>
        <Box className="reason-container">
          <Typography variant="body-16-semibold" component="span">
            {t('reason')}:
          </Typography>
          <Typography variant="body-16-regular" component="span">
            {` ${note}`}
          </Typography>
        </Box>
        <Box className="contact-info-box">
          <InfoRounded className="info-icon" />
          <Typography
            variant="body-14-regular"
            dangerouslySetInnerHTML={{
              __html: sanitize(
                t('reasonContactInfoNew', {
                  SUPPORT_CENTER_URL: `${LANDING_PAGE_URL}/support`,
                  VBEE_ZALO_URL,
                }),
                {
                  allowedTags: ['a'],
                  allowedAttributes: { a: ['href', 'style', 'target'] },
                },
              ),
            }}
          />
        </Box>
      </DialogContent>
      <Box className="dialog-actions">
        <CommonButton
          variant="outlineSmall"
          onClick={handleDuplicateVoice}
          customStyle={{
            height: '40px',
            borderRadius: '8px',
            padding: '8px 24px',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
        >
          {isDuplicateVoice ? t('duplicateVoice') : t('createNewVoice')}
        </CommonButton>
        <CommonButton
          variant="containedSmallNonBorder"
          onClick={handleUnderstood}
          customStyle={{
            height: '40px',
            borderRadius: '8px',
            padding: '8px 24px',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
        >
          {t('understand')}
        </CommonButton>
      </Box>
    </StyledViewReasonNew>
  );
};

export default ViewReasonNew;
